import { Navigate } from "react-router-dom";

// The old per-package pages (/services/:slug) have been retired.
// All legacy URLs redirect to the two-pathway services page.
export default function ServicePage() {
  return <Navigate to="/services" replace />;
}
